import FileSaver from 'file-saver'
import moment from 'moment'

import Make from '.'
import { CampaignLinkRawData } from '../../types/campaign-codes'
import { removeSpecialChars } from '../../../helpers'

const make = Make('report/', true)

export const getCampaignLinkRawData = async (
  data: CampaignLinkRawData,
  fileName?: string,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'campaign-link-dashboard-raw-data',
    data,
    options: {
      ...data,
      headers: {
        'Content-Type':
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  })

  if (!req.success) {
    return false
  }

  if (req.res.data) {
    // @ts-ignore
    const blob = new Blob([new Uint8Array(req.res.data)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const now = new Date(Date.now())
    await FileSaver.saveAs(
      blob,
      `${moment(now).format('YYYY-MM-DD')}_${
        fileName ? removeSpecialChars(fileName) : 'Link_Performance_Export'
      }.xlsx`,
    )
  }

  return true
}

export interface LostLinksRawData {
  startDate: string
  endDate?: string
  granularity: string
  selectedMetric: string
  offset: number
  limit: number
  sortDirection: 'ASC' | 'DESC'
  applyFilters?: {
    dimensionName: string
    dimensionParameterID: string
    dimensionOptions: string[]
  }[]
  searchFilter?: {
    searchField: string
    searchValue: string
  }
  tempTable: string
}

export const getLostLinksRawData = async (
  data: LostLinksRawData,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: '/link-audit-raw-data',
    data,
    options: {
      ...data,
      headers: {
        'Content-Type':
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  })

  if (!req.success) return false

  if (req.res.data) {
    // @ts-ignore
    const blob = new Blob([new Uint8Array(req.res.data)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const now = new Date(Date.now())
    await FileSaver.saveAs(
      blob,
      `${moment(now).format('YYYY-MM-DD')}_Other_links_audit.xlsx`,
    )
  }

  return true
}
